import React from 'react';
import { Box } from '@mui/material';
import home from './assets/home.svg';
import tenants from './assets/tenants.svg';
import showrooms from './assets/showrooms.svg';
import releases from './assets/releases.svg';
import mqtt from './assets/mqtt.svg';
import ai from './assets/ai.svg';
import insights from './assets/insights.svg';
import access from './assets/access.svg';
import search from './assets/search.svg';
import plus from './assets/plus.svg';
import collapse from './assets/collapse.svg';
import alert from './assets/alert.svg';
import lock from './assets/lock.svg';
import arrow from './assets/arrow.svg';
import loader from './assets/loader.svg';
import logo from './assets/logo.svg';
import help from './assets/help.svg';
import settings from './assets/settings.svg';
import userPlus from './assets/userPlus.svg';
import bell from './assets/bell.svg';
import chevron from './assets/chevron.svg';

const assets = { home, tenants, showrooms, releases, mqtt, ai, insights, access, search, plus, collapse, alert, lock, arrow, loader, logo, help, settings, userPlus, bell, chevron };
export type PilotIconName = keyof typeof assets;

/** Exact Figma component exports, tinted with CSS so both themes stay legible. */
export default function PilotIcon({ name, size = 20 }: { name: PilotIconName; size?: number }) {
  if (name === 'logo') return <Box component="img" src={assets.logo} alt="" aria-hidden="true" sx={{ width: size, height: size, objectFit: 'contain', flexShrink: 0, filter: theme => theme.palette.mode === 'light' ? 'brightness(0.25)' : 'none' }} />;
  return <Box component="span" aria-hidden="true" sx={{ display: 'inline-block', width: size, height: size, flexShrink: 0, bgcolor: 'currentColor', mask: `url(${assets[name]}) center / contain no-repeat`, WebkitMask: `url(${assets[name]}) center / contain no-repeat` }} />;
}
